<template>
  <validation-observer ref="validationobserver" v-slot="{ handleSubmit }">
    <b-form @submit.prevent="handleSubmit(salvarImpedimento)">
      <b-overlay :show="screenBlocked">
        <b-card header-tag="header" class="m-3" no-body>
          <template #header>
            <h6 class="mb-0 text-center">
              <span class="titulo-sagres font-weight-bold">
                {{ isEdit ? "Editar" : "Novo" }} Impedimento
              </span>
              <btn-voltar />
              <b-button class="float-right m-1" size="sm" type="submit">
                <font-awesome-icon icon="save" />
                Salvar
              </b-button>
            </h6>
          </template>
          <b-card-body>
            <div v-if="codUgLogado === codUgTce">
              <h6 class="mb-0 text-left font-weight-bold">Unidade Gestora</h6>
              <br />
              <b-row>
                <b-col cols="12" xl="4">
                  <default-form-validation-provider label="Escolha a UG" v-slot="defaultState">
                    <div id="ugSelectWrapper" class="wrapper-multiselect-sagres">
                      <multiselect v-model="ugSelecionada" open-direction="bottom" :state="defaultState.state"
                        :placeholder="`Selecione...`" track-by="value" :options="comboUgs" :allow-empty="true"
                        label="text" close-on-select searchable deselect-label="" :show-labels="false"
                        @select="atualizaUGSelecionada" />
                    </div>
                  </default-form-validation-provider>
                </b-col>
              </b-row>
            </div>
            <h6 class="mb-0 text-left font-weight-bold">Dados Pessoais</h6>
            <br />
            <b-row>
              <b-col cols="12" xl="3">
                <default-form-validation-provider label="Tipo de Pessoa" v-slot="defaultState">
                  <b-form-select id="select-pessoa" v-model="impedimento.TpPessoa" :options="comboPessoa"
                    :state="defaultState.state">
                  </b-form-select>
                </default-form-validation-provider>
              </b-col>
              <b-col cols="12" xl="3">
                <default-form-validation-provider label="CPF / CNPJ" rules="required|min:11|max:18" v-slot="defState">
                  <b-form-input id="input-cpf-cnpj" v-model="impedimento.NrCpfcnpj" type="text" :state="defState.state">
                  </b-form-input>
                </default-form-validation-provider>
              </b-col>
              <b-col cols="12" xl="6">
                <default-form-validation-provider label="Nome" rules="required|max:120" v-slot="defState">
                  <b-form-input id="input-nome" v-model="impedimento.NmNome" :state="defState.state" type="text">
                  </b-form-input>
                </default-form-validation-provider>
              </b-col>
            </b-row>

            <br />
            <h6 class="mb-0 text-left font-weight-bold">Dados da Proibição</h6>
            <br />
            <b-row>
              <b-col cols="12" xl="3">
                <default-form-validation-provider label="Tipo de Impedimento" v-slot="defaultState">
                  <b-form-select id="select-tipo-impedimento" v-model="impedimento.IdFundamento"
                    :options="comboTiposDeImpedimento" :state="defaultState.state">
                  </b-form-select>
                </default-form-validation-provider>
              </b-col>
              <b-col cols="12" xl="3">
                <default-form-validation-provider label="Número do Impedimento" rules="required|numeric|max:20" v-slot="defState">
                  <b-form-input id="input-nr-impedimento" v-model="impedimento.NrFundamento" type="number"
                    :state="defState.state">
                  </b-form-input>
                </default-form-validation-provider>
              </b-col>
              <b-col cols="12" xl="6">
                <default-form-validation-provider label="Data do Impedimento" v-slot="defState">
                  <b-form-datepicker id="date-dt-impedimento" v-model="impedimento.DtFundamento" :state="defState.state"
                    placeholder="Selecione uma data" value-as-date label-no-date-selected="Nenhuma data selecionada">
                  </b-form-datepicker>
                </default-form-validation-provider>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" md="6">
                <default-form-validation-provider label="Motivo / Base Legal" rules="required|max:8000" v-slot="defState">
                  <b-form-textarea id="text-base-legal" :state="defState.state" v-model="impedimento.DeBaselegal" rows="5">
                  </b-form-textarea>
                </default-form-validation-provider>
              </b-col>
              <b-col cols="12" xl="6">
                <default-form-validation-provider label="Início da Proibição" v-slot="defState">
                  <b-form-datepicker id="date-inicio-proibicao" v-model="impedimento.DtInicioimpedimento"
                    :state="defState.state" placeholder="Selecione uma data" value-as-date
                    label-no-date-selected="Nenhuma data selecionada">
                  </b-form-datepicker>
                </default-form-validation-provider>
                <default-form-validation-provider label="Fim da Proibição" v-slot="defState">
                  <b-form-datepicker id="date-fim-proibicao" v-model="impedimento.DtFimimpedimento"
                    :state="defState.state" placeholder="Selecione uma data" value-as-date
                    label-no-date-selected="Nenhuma data selecionada">
                  </b-form-datepicker>
                </default-form-validation-provider>
              </b-col>

            </b-row>

            <br />
            <h6 class="mb-0 text-left font-weight-bold">
              Dados do Registro do Protocolo
            </h6>
            <br />
            <b-row>
              <b-col cols="12" xl="6">
                <b-form-group id="input-group-ano-numero-protocolo" label-size="md" label="Ano / Número">
                  <div class="d-flex align-items-center justify-content-center">
                    <default-form-validation-provider noLabel v-slot="defState"
                      :rules="ugChecking === true ? 'required|min:4|max:4|numeric' : 'min:4|max:4|numeric'">
                      <b-form-input id="input-ano-protocolo" v-model="impedimento.NrAnoprotocolo" type="number"
                        :state="defState.state">
                      </b-form-input>
                    </default-form-validation-provider>
                    <span class="mx-4">/</span>
                    <default-form-validation-provider noLabel v-slot="defState"
                      :rules="ugChecking === true ? 'required|min:6|max:6|numeric' : 'min:6|max:6|numeric'">
                      <b-form-input id="input-nr-protocolo" v-model="impedimento.NrProtocolo" type="number"
                        @blur="zeroPadNrProtocolo" :state="defState.state">
                      </b-form-input>
                    </default-form-validation-provider>
                  </div>
                </b-form-group>
              </b-col>
              <b-col cols="12" xl="6">
                <b-form-group id="input-group-dt-protocolo" label-size="md" label="Data">
                  <default-form-validation-provider noLabel v-slot="defState"
                    :rules="ugChecking === true ? 'required' : ''">
                    <b-form-datepicker id="date-dt-protocolo" v-model="impedimento.DtProtocolo"
                      placeholder="Selecione uma data" value-as-date label-no-date-selected="Nenhuma data selecionada"
                      :state="defState.state">
                    </b-form-datepicker>
                  </default-form-validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <br />
            <h6 class="mb-0 text-left font-weight-bold">Arquivo</h6>
            <br />
            <b-row>
              <b-col cols="12" xl="6">
                <b-form-group id="input-group-arquivo" label-size="md" label="Arquivo texto do impedimento (PDF)">

                  <div v-if="impedimento.arquivoImpedimento">
                    <span>Nome: {{ impedimento.arquivoImpedimento.NmArquivo
                    }}</span>
                    <div class="d-flex justify-content-center">
                      <btn-download class="mr-2" :fazerDownload="() => baixarAnexo(impedimento.arquivoImpedimento.NmArquivo)" />
                      <b-link class="text-dark" @click="removerAnexo()">
                        <font-awesome-icon icon="times" />
                        <div style="font-size: 12px">Remover</div>
                      </b-link>
                    </div>
                  </div>
                  <div v-else>
                    <default-form-validation-provider noLabel v-slot="defState">
                      <b-form-file v-model="impedimento.arquivo" placeholder="Nenhum arquivo selecionado"
                        :state="defState.state" accept="application/pdf" @input="validarTamanhoArquivo">
                      </b-form-file>
                    </default-form-validation-provider>
                  </div>
                </b-form-group>

              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-overlay>
    </b-form>
  </validation-observer>
</template>

<script lang="ts">
import { Vue, Component, Ref } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import BtnVoltar from "@/components/shared/BtnVoltar.vue";
import Multiselect from "vue-multiselect";

import { ValidationObserver } from "vee-validate";
import DefaultFormValidationProvider from "@/components/shared/DefaultFormValidationProvider.vue";
import { UtilsTS } from "@/utilsts";
import { SelectValue } from "@/types/select-value";
import impedidosService from "@/services/contratacao/impedidosService";
import { Impedimentos } from "@/types/contratacao/impedimentos";
import btnDownload from "@/components/shared/btn-download.vue";

import { store } from "@/store";
import { PortalError } from "@/types/portal-error";


const CompProps = Vue.extend({
  name: "EditarImpedimento",
  components: {
    BtnVoltar,
    btnDownload,
    DefaultFormValidationProvider,
    ValidationObserver,
    Multiselect,
  },
  props: {
    idImpedimento: {
      type: String,
      required: false,
    },
  },
});

type ValidationStateParams = {
  dirty: boolean;
  validated: boolean;
  valid: boolean | null;
};

const LIMITES_IMPEDIMENTO = {
  nrCpfcnpj: 14,
  nmNome: 120,
  nrFundamento: 20,
  nrAnoProtocolo: 4,
  nrProtocolo: 6,
  deBaseLegal: 8000,
  deEspecificaFundamento: 120,
};

@Component
export default class EditarImpedimento extends mixins(UtilsTS, CompProps) {
  @Ref("validationobserver") validationobserver: InstanceType<
    typeof ValidationObserver
  >;
  codUgLogado = store.codigoUG;
  codUgTce = "003101";
  ugSelecionada: SelectValue = { text: "Selecione...", value: null };
  comboPessoa: SelectValue[] = [];
  comboTiposDeImpedimento: SelectValue[] = [];
  comboUgs: SelectValue[] = [];
  impedimento = new Impedimentos();
  screenBlocked = false;
  ugChecking = false
  get isEdit() {
    return this.idImpedimento !== undefined && this.idImpedimento !== null;
  }


  async mounted(): Promise<void> {
    try {
      this.screenBlocked = true;
      await this.getCombos();
      if (this.isEdit) {

        this.impedimento = await impedidosService.getImpedimentoId(
          this.idImpedimento
        );

      } else {
        if (this.codUgLogado !== undefined && this.codUgLogado !== null && this.codUgLogado !== "") {
          this.impedimento.CodUgSagres = this.codUgLogado;
        }
      }

      if (this.codUgLogado === this.codUgTce) {
        this.ugChecking = true
        await this.getUnidadesGestoras();
        this.ugSelecionada = this.comboUgs.find(
          (x) => x.value === this.impedimento.CodUgSagres
        ) as SelectValue;
      }
    } catch (e: any) {
      console.error("Erro ao receber dados do impedimento", e);
    } finally {
      this.screenBlocked = false;
    }

  }

  async salvarImpedimento(): Promise<void> {
    try {
      const isValid = await this.validationobserver.validate();
      if (!isValid) {
        console.error(this.validationobserver);
        return;
      }

      this.screenBlocked = true;

      const impedimentoNormalizado = this.normalizarImpedimentoParaEnvio(this.impedimento);

      const response = !this.isEdit
        ? await impedidosService.salvarImpedimento(impedimentoNormalizado)
        : await impedidosService.alterarImpedimento(
          this.idImpedimento,
          impedimentoNormalizado
        );
      if (response && response.status == 200) {
        this.$toast.success(`Impedimento salvo com sucesso!`);
        this.$router.push("/contratacao/impedidos-de-contratar");
      } else {
        throw new PortalError(
         response.data?.erros || "Erro ao salvar impedimento"
        );
      }
    } catch (e: unknown) {
      console.error("Erro ao salvar impedimento", e, this.impedimento);
      if (e instanceof Error) {
        this.$toast.error(e.message);
      } else {
        this.$toast.error("Erro ao salvar impedimento.");
      }
    } finally {
      this.screenBlocked = false;
    }
  }

  getValidationState({
    dirty,
    validated,
    valid = null,
  }: ValidationStateParams): boolean | null {
    return dirty || validated ? valid : null;
  }

  normalizarImpedimentoParaEnvio(impedimento: Impedimentos): Impedimentos {
    const impedimentoNormalizado = Object.assign(new Impedimentos(), impedimento);

    impedimentoNormalizado.NrCpfcnpj = this.digitsOnly(
      String(impedimentoNormalizado.NrCpfcnpj ?? ""),
      LIMITES_IMPEDIMENTO.nrCpfcnpj,
    );
    impedimentoNormalizado.NmNome = String(impedimentoNormalizado.NmNome ?? "").slice(
      0,
      LIMITES_IMPEDIMENTO.nmNome,
    );
    impedimentoNormalizado.NrFundamento = this.digitsOnly(
      String(impedimentoNormalizado.NrFundamento ?? ""),
      LIMITES_IMPEDIMENTO.nrFundamento,
    );
    impedimentoNormalizado.NrAnoprotocolo = this.digitsOnly(
      String(impedimentoNormalizado.NrAnoprotocolo ?? ""),
      LIMITES_IMPEDIMENTO.nrAnoProtocolo,
    );
    impedimentoNormalizado.NrProtocolo = this.digitsOnly(
      String(impedimentoNormalizado.NrProtocolo ?? ""),
      LIMITES_IMPEDIMENTO.nrProtocolo,
    );
    impedimentoNormalizado.DeBaselegal = String(
      impedimentoNormalizado.DeBaselegal ?? "",
    ).slice(0, LIMITES_IMPEDIMENTO.deBaseLegal);
    impedimentoNormalizado.DeEspecificafundamento = String(
      impedimentoNormalizado.DeEspecificafundamento ?? "",
    ).slice(0, LIMITES_IMPEDIMENTO.deEspecificaFundamento);

    return impedimentoNormalizado;
  }

  async getCombos(): Promise<void> {
    try {
      const combos = await impedidosService.getCombosConsultaImpedidos();
      this.comboPessoa = [
        { text: "SELECIONE", value: "", disabled: true },
        { text: "Física", value: "F" },
        { text: "Jurídica", value: "J" },
      ];
      this.comboTiposDeImpedimento = [
        { text: "SELECIONE", value: "", disabled: true },
        ...combos.tiposImpedimento.map((tp) => {
          return { text: tp.DeFundamento, value: tp.IdFundamento };
        }),
      ];
    } catch (e: unknown) {
      console.error("Erro ao obter combos...", e);
      throw e;
    }
  }

  async getUnidadesGestoras(): Promise<void> {
    try {
      const ugs = await impedidosService.getUnidadesGestoras();

      this.comboUgs = [
        { text: "SELECIONE", value: "", disabled: true },
        ...ugs.map((ug) => {
          return { text: ug.NmNome, value: ug.CodUgSagres };
        }),
      ];
    } catch (e: unknown) {
      console.error("Erro ao obter lista de ugs...", e);
      throw e;
    }
  }

  atualizaUGSelecionada(): void {
    this.impedimento.CodUgSagres = this.ugSelecionada.value as string;
  }

  zeroPadNrProtocolo(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.value.length === 0) return;

    this.impedimento.NrProtocolo = this.padZeros(
      +this.impedimento.NrProtocolo,
      6
    );
  }

  async baixarAnexo(nomeArquivo: string): Promise<void> {
    try {
      const response = await impedidosService.baixarAnexoImpedimento(this.impedimento.IdImpedimento)
      this.download(nomeArquivo || `arquivo-impedimento-${this.impedimento.IdImpedimento}`, response.data)
    } catch (e: unknown) {
      this.tratarError(e)
    }
  }

  removerAnexo(): void {
    this.impedimento.arquivoImpedimento = undefined;
  }

  validarTamanhoArquivo(): void {
    if (
      this.impedimento?.arquivo &&
      this.impedimento.arquivo instanceof File &&
      this.impedimento.arquivo.size > this.valor10MBemBytes
    ) {
      this.$toast.error(`O arquivo selecionado excede o tamanho máximo de 10 MB.`);
      this.$nextTick(() => {
        this.impedimento.arquivo = null;
      });
    }
  }
}
</script>

<style>
:deep(#ugSelectWrapper.invalid .multiselect__tags) {
  border: #dc3545 solid 1px !important;
  border-radius: 3px !important;
}

:deep(#ugSelectWrapper.valid .multiselect__tags) {
  border: #28a745 solid 1px !important;
  border-radius: 3px !important;
}

:deep(#ugSelectWrapper label) {
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #dc3545;
  text-align: left;
}
</style>
